module.exports = __webpack_public_path__ + "img/setup-vented-pipe-min.5e4d6cda.jpg";